import { Component } from 'nuxt-property-decorator';
import { Context } from '@nuxt/types';
import BinderBase from '@/components/shared/binder-base';
import { parseBinderItemsResponse } from '@/utils/binderFoldersUtils';
import { MetaInfo } from 'vue-meta';

@Component
export default class SharedHighlightById extends BinderBase {
  head(): MetaInfo {
    const highlight = this.items && this.items.length > 0 ? this.items[0] : null;
    return {
      title: highlight != null ? `${highlight.headingText}(${highlight.doc.title})の共有ハイライト` : '',
    };
  }

  async asyncData({
    app: { $repositories, $auth },
    error,
    route,
  }: Context): Promise<Pick<SharedHighlightById, 'binder' | 'folder' | 'id' | 'items'> | undefined> {
    if (!$auth.permissions.binder) {
      error({ statusCode: 403, message: 'このページは閲覧できません' });
    } else {
      const id = route.params.id;
      const highlightId = route.params.highlight;
      try {
        const { binder, folder, items } = parseBinderItemsResponse(
          await $repositories.binderFolders.getSharedBinderItems(id),
        );
        const filteredItems = items.filter((item) => item.type === 'highlight' && item.id === highlightId);
        if (filteredItems.length < 1) throw new Error('対象のハイライトがレスポンスに含まれていません');
        return { binder, folder, id, items: filteredItems };
      } catch (error) {
        console.error(error);
        throw new Error(
          'ハイライトの読み込みに失敗しました。このハイライトは共有したユーザーが削除した可能性があります',
        );
      }
    }
  }
}
